import { lazy, Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AppLayout } from '@/app/layouts/AppLayout';

// Lazy so the 3D bundle is loaded as its own chunk rather than in the app shell.
const ConfiguratorPage = lazy(() => import('@/features/configurator/ConfiguratorPage'));

// The configurator is the app. `/configure/:id` stays a route of its own so a link to a
// saved configuration keeps working; both render the same page.
const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <ConfiguratorPage /> },
      { path: 'configure/:configurationId?', element: <ConfiguratorPage /> },
    ],
  },
]);

export function AppRouter() {
  return (
    <Suspense fallback={<p role="status">Loading…</p>}>
      <RouterProvider router={router} />
    </Suspense>
  );
}
